import { Link, useNavigate } from "react-router-dom";
import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ILogin } from "../../shared/interfaces/user/IUser";
import { useDispatch } from "react-redux";
import authSlice from "../../store/slices/auth.slice";
import { AuthService } from "./service";
import { handleError } from "../../shared/functions/handleError";
import { enqueueSnackbar } from "notistack";

export const loginSchema = yup.object({
  email: yup.string().email().required("validation.required"),
  password: yup
    .string()
    .min(8, "validation.passMinLength")
    .max(32)
    .required("validation.required"),
});

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<ILogin>({
    defaultValues: {
      email: "",
      password: "",
    },
    resolver: yupResolver(loginSchema),
  });

  const onSubmit = async (data: ILogin) => {
    await AuthService.login(data)
      .then(async (response) => {
        localStorage.setItem("token", response?.data?.accessToken);
        await AuthService.me()
          .then((meResponse) => {
            if (meResponse) {
              navigate("/dashboard");

              enqueueSnackbar(t("toasts.successfullyLoggedIn"), {
                variant: "success",
              });

              dispatch(
                authSlice.actions.setLoginState({
                  isAuthenticated: true,
                  token: response?.data?.accessToken,
                  userData: meResponse,
                }),
              );
            }
          })
          .catch(handleError);
      })
      .catch(handleError);
  };
  return (
    <React.Fragment>
      <div className="auth-main v1">
        <div className="auth-wrapper">
          <div className="auth-form">
            <Card className="my-5">
              <Card.Body>
                <div className="text-center">
                  <img
                    src={"/assets/images/authentication/img-auth-login.png"}
                    alt="images"
                    className="img-fluid mb-3"
                  />
                  <h4 className="f-w-500 mb-1">{t("auth.loginEmail")}</h4>
                  {/*<p className="mb-3">*/}
                  {/*  {t("auth.noAccount")}{" "}*/}
                  {/*  <Link to={"/register"} className="link-primary ms-1">*/}
                  {/*    {t("auth.createAccount")}*/}
                  {/*  </Link>*/}
                  {/*</p>*/}
                </div>
                <Form onSubmit={handleSubmit(onSubmit)} noValidate>
                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>{t("general.email")}</Form.Label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="email"
                          placeholder={t("general.email")}
                          isInvalid={!!errors.email?.message}
                        />
                      )}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email?.message &&
                        t(errors.email.message as string)}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="password">
                    <Form.Label>{t("general.password")}</Form.Label>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="password"
                          placeholder={t("general.password")}
                          isInvalid={!!errors.password?.message}
                        />
                      )}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password?.message &&
                        t(errors.password.message as string)}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <div className="d-flex mt-1 justify-content-between align-items-center">
                    <Link to="/forgot-password">
                      <h6 className="f-w-400 mb-0">
                        {t("auth.forgotPassword")}
                      </h6>
                    </Link>
                  </div>
                  <div className="d-grid mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? t("auth.loggingIn") : t("auth.login")}
                    </button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </div>

          <div className="auth-sidefooter">
            <Row>
              <Col md={2}>
                <img
                  src={"/assets/images/logo-horizontal.png"}
                  className="img-brand img-fluid w-100"
                  alt="images"
                />
              </Col>
            </Row>

            <hr className="mb-3 mt-4" />
            <Row>
              <div className="col my-1">
                <p className="m-0">
                  {t("general.developedBy")}
                  <a href="https://itmedia.io/" target="_blank">
                    {" "}
                    itMedia
                  </a>
                </p>
              </div>
              <div className="col-auto my-1">
                <ul className="list-inline footer-link mb-0">
                  <li className="list-inline-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="list-inline-item">
                    <Link to="https://itmedia.io/" target="_blank">
                      Support
                    </Link>
                  </li>
                </ul>
              </div>
            </Row>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
